/**
 * Fixes input maxLength not working on Xiaomi mobiles (Ana)
 * @param e - key down event
 */
 export const handleOnKeyDown = e => {
    const { target } = e;
    if (target.value !== '' && e.keyCode !== 8 && e.keyCode !== 9) {
        // Filled input and not backspace/delete key
        e.preventDefault();
        return;
    }
};